// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as UserContext$LiteracyplanetClientFlags from "./UserContext.res.mjs";
import * as LocalStorage$LiteracyplanetClientFlags from "./LocalStorage.res.mjs";
import * as CobraGenericBehaviourContext$LiteracyplanetClientFlags from "./CobraGenericBehaviourContext.res.mjs";

var key = "areSoundEffectsEnabled";

function toString(t) {
  return Belt_Option.getExn(JSON.stringify(t));
}

function fromString(data) {
  return Belt_Option.map(data, (function (d) {
                return JSON.parse(d);
              }));
}

var S = {
  key: key,
  toString: toString,
  fromString: fromString
};

var $$Storage = LocalStorage$LiteracyplanetClientFlags.Make({
      key: key,
      fromString: fromString,
      toString: toString
    });

function use(param) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var match = Curry._1($$Storage.useLocalStorageWithNamespace, userId);
  return [
          Belt_Option.getWithDefault(match[0], true),
          match[1]
        ];
}

var $$Storage$1 = {
  S: S,
  $$Storage: $$Storage,
  use: use
};

function CobraGenericBehaviour(props) {
  var match = use();
  var setStorage = match[1];
  return React.createElement(CobraGenericBehaviourContext$LiteracyplanetClientFlags.Provider.make, {
              value: {
                props: {
                  areSoundEffectsEnabled: match[0],
                  myFont: props.myFont
                },
                onDispatch: {
                  onEnableSoundEffects: (function (param) {
                      Curry._1(setStorage, true);
                    }),
                  onDisableSoundEffects: (function (param) {
                      Curry._1(setStorage, false);
                    })
                }
              },
              children: props.children
            });
}

var make = CobraGenericBehaviour;

export {
  $$Storage$1 as $$Storage,
  make ,
}
/* Storage Not a pure module */
